// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"MessageCustom_messageContainer__1zVIy","message":"MessageCustom_message__2Ew6L","messageLast":"MessageCustom_messageLast__aSj2k"};